var _circle, _circle2, _circle3, _circle4, _circle5, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBoxPrimarySm = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 152,
  height: 131,
  fill: "none",
  viewBox: "0 0 152 131",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 76,
  cy: 58,
  r: 52,
  fill: "var(--utility-brand-200, black)"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 25,
  r: 5,
  fill: "var(--utility-brand-100, black)"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 18,
  cy: 109,
  r: 7,
  fill: "var(--utility-brand-100, black)"
})), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 41,
  r: 7,
  fill: "var(--utility-brand-100, black)"
})), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
  cx: 134,
  cy: 14,
  r: 4,
  fill: "var(--utility-brand-100, black)"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-200, black)",
  d: "m76 36.063 4.536-1.9-4.535 1.932V90.19l41.795-17.515V18.557l.204-.086-.204-.09v-.091l-.104.045L76.33 0 34 18.031l.2.087-.2 53.899 42 18.14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-200, black)",
  d: "M76 36.063v54.095L34 72.017l.2-53.9z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-100, black)",
  d: "M76 36.095V90.19l41.796-17.514V18.29z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-100, black)",
  d: "m76 36.063 42-17.592L76.33 0 34 18.031z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-200, black)",
  d: "M49.832 11.287 91.672 29.5l.38 13.27 11.707-4.83-.354-13.354L60.327 6.817z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "var(--utility-brand-400, black)",
  d: "M52 92c0-13.255 10.745-24 24-24s24 10.745 24 24-10.745 24-24 24-24-10.745-24-24"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--fg-white)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m72 96 4-4m0 0 4 4m-4-4v9m8-4.257A5.5 5.5 0 0 0 80.5 87a.62.62 0 0 1-.534-.302 7.5 7.5 0 1 0-11.78 9.096"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: 124,
  height: 130.19,
  x: 14,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect1_dropShadow_1182_1639"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 8
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.03 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1182_1639"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feMorphology", {
  in: "SourceAlpha",
  radius: 4,
  result: "effect2_dropShadow_1182_1639"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 20
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 12
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.08 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "effect1_dropShadow_1182_1639",
  result: "effect2_dropShadow_1182_1639"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect2_dropShadow_1182_1639",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "b",
  width: 64,
  height: 64,
  x: 44,
  y: 60,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "BackgroundImageFix",
  stdDeviation: 4
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "SourceAlpha",
  operator: "in",
  result: "effect1_backgroundBlur_1182_1639"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_backgroundBlur_1182_1639",
  result: "shape"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBoxPrimarySm);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BoxPrimarySm.92381fff3d505b66995405cf48f2b69d.svg";